import React, { FC } from "react";
import { Grid, Box, Typography } from "@mui/material";

import logo from "../../assets/Purple Lucent AI.png";
import Ally from "../../assets/Ally.mp4";

const ChatPlaceholder: FC = (): JSX.Element => {
  return (
    <Grid
      container
      sx={{
        width: "100%",
        height: "100vh", // full viewport height
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // pushes top & bottom apart
        alignItems: "center",
        textAlign: "center",
        px: { xs: 2, md: 4 },
        py: 2,
      }}
    >
      <Box></Box>

      {/* --- Logo in middle --- */}
      <Box
        component="img"
        src={logo}
        alt="LucentAI logo"
        sx={{
          width: { xs: 280, sm: 360, md: 400 },
          height: "auto",
          userSelect: "none",
          my: 2,
        }}
      />

      {/* --- Bottom text --- */}
      <Typography
        color="text.primary"
        fontWeight="bold"
        sx={{
          fontSize: { xs: "13px", sm: "15px" },
        }}
      >
        By using LucentAI, you acknowledge the LucentAI AI Policy and
        responsible use guidelines.
      </Typography>
    </Grid>
  );
};

export default ChatPlaceholder;
